import { render, staticRenderFns } from "./modal_transfer.vue?vue&type=template&id=28379081&scoped=true&"
import script from "./modal_transfer.vue?vue&type=script&lang=js&"
export * from "./modal_transfer.vue?vue&type=script&lang=js&"
import style0 from "./modal_transfer.vue?vue&type=style&index=0&id=28379081&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28379081",
  null
  
)

export default component.exports